<template>
  <div id="main-wrapper">
    <vue-progress-bar></vue-progress-bar>
    <header-bar :isConnected='isConnected'/>
    <side-bar/>
    <div class="page-wrapper">
      <div class="container-fluid">
        <router-view/>
      </div>
    </div>
  </div> 
</template>

<script>
import HeaderBar from '@/components/Layout/Header'
import SideBar from '@/components/Layout/Sidebar'
export default {
  components: {
    HeaderBar,
    SideBar
  },
  data () {
    return {
      isConnected: this.$socket.connected
    }
  },
  sockets: {
    connect: function () {
      this.isConnected = this.$socket.connected
      this.$socket.emit('join', {locationCode: this.$ls.get('locationCode'), deviceId: this.$ls.get('deviceId')})
      $.toast({
        heading: 'Server is back up',
        text: 'Connections has been established between client and server',
        position: 'top-right',
        showHideTransition: 'slide',
        icon: 'info'
      })
    },
    disconnect: function () {
      this.isConnected = this.$socket.connected
    },
    message: function (val) {
      console.log(val)
    }
  },
  mounted () {
    // this.$lang.setLang('sp')
    // this.$i18n.locale = 'sp'
    var set = function () {
      var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width
      var topOffset = 70
      if (width < 1170) {
        $('body').addClass('mini-sidebar')
        $('.navbar-brand span').hide()
        $('.scroll-sidebar, .slimScrollDiv').css('overflow-x', 'visible').parent().css('overflow', 'visible')
        $('.sidebartoggler i').addClass('ti-menu')
      } else {
        $('body').removeClass('mini-sidebar')
        $('.navbar-brand span').show()
      }
      var height = ((window.innerHeight > 0) ? window.innerHeight : this.screen.height) - 1
      height = height - topOffset
      if (height < 1) height = 1
      if (height > topOffset) {
        $('.page-wrapper').css('min-height', (height) + 'px')
      }
    }
    $(window).ready(set)
    // ==============================================================
    // Sidebarmenu
    // ==============================================================
    $('#sidebarnav').metisMenu()
    // ==============================================================
    // Slimscrollbars
    // ==============================================================
    // $('.scroll-sidebar').slimScroll({
    //   position: 'left',
    //   size: '5px',
    //   height: '100%',
    //   color: '#dcdcdc'
    // })
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Layout/Layout.vue